import React, { useContext, useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import galleryModel from '../model/GalleryModel';
import GalleryCanvasToolbar from '../toolbar/GalleryCanvasToolbar';

import { AppContext } from '../App';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: `calc(100vh - 62px)`,
      width: '100%',
      padding: '0 0 0 10px',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'scale-down',
    },
    toolbar: {
      position: 'relative',
      top: '-15%',
      left: '50%',
      transform: `translate(-50%, -50%)`,
      width: 300,
      pointerEvents: 'none',
    },
  })
);

const GalleryCanvas = () => {
  const classes = useStyles();
  const model = galleryModel;
  const sz = model.snapshotsSize();
  const [imgSrc, setImgSrc] = useState('');
  const { galleryChanged, setGalleryChanged } = useContext(AppContext);

  const updateCanvas = () => {
    setImgSrc(model.previewSnapshot());
    setGalleryChanged((v) => !v);
  };

  useEffect(() => {
    setImgSrc(model.previewSnapshot());
  }, [galleryChanged]);

  const image = imgSrc ? imgSrc : model.previewSnapshot();
  const prevAvailable = model.isPrevAvailable();
  const nextAvailable = model.isNextAvailable();
  return (
    <div className={classes.root}>
      {sz > 0 && <img className={classes.image} src={image} />}
      {sz > 0 && (
        <div className={classes.toolbar}>
          <GalleryCanvasToolbar
            imgSrc={image}
            prevAvailable={prevAvailable}
            nextAvailable={nextAvailable}
            onNext={() => {
              model.onNextSnapshot();
              updateCanvas();
            }}
            onPrev={() => {
              model.onPrevSnapshot();
              updateCanvas();
            }}
            onDelete={() => {
              model.onDeleteSnapshot();
              updateCanvas();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default GalleryCanvas;
